import { NU_TO_PU } from "../constants";
export class MappingItem {
    // ncodePoints: IPoint[] = new Array(4);
    // pdfPoints: IPoint[] = new Array(4);
    constructor(pdfPageNo) {
        this._page = {
            pdfPageNo: undefined,
            pageInfo: {},
            basePageInfo: {},
            npageArea: [],
            pdfDesc: {},
            h: {},
            h_rev: {},
        };
        this.setPointsFromRect = (target, rc) => {
            const x0 = rc.x;
            const y0 = rc.y;
            const x1 = x0 + rc.width;
            const y1 = y0 + rc.height;
            let unit; // ncode unit
            if (target === "pdf") {
                unit = "pu"; // pdf unit
            }
            else {
                unit = "nu";
            }
            const points = {
                type: "homography",
                unit,
                pts: [
                    { x: x0, y: y0 },
                    { x: x1, y: y0 },
                    { x: x1, y: y1 },
                    { x: x0, y: y1 }
                ]
            };
            if (target === "pdf") {
                this._dstPts = points;
            }
            else {
                this._srcPts = points;
            }
        };
        this.setSrc4Points_ncode = (points) => {
            this._srcPts = {
                type: "homography",
                unit: "nu",
                pts: [...points],
            };
        };
        this.setDst4Points_pdf = (points) => {
            this._dstPts = {
                type: "homography",
                unit: "pu",
                pts: [...points],
            };
        };
        this.setNcodeArea = (arg) => {
            const { rect: area_nu } = arg;
            this._srcPts = {};
            this.setPointsFromRect("ncode", area_nu);
            this._page.pageInfo = Object.assign({}, arg.pageInfo);
            this._page.basePageInfo = Object.assign({}, arg.basePageInfo);
            this._page.npageArea = [...arg.npageArea];
        };
        this.setPdfArea = (arg) => {
            const { rect: area_pu } = arg;
            this._dstPts = {};
            this.setPointsFromRect("pdf", area_pu);
            this._page.pdfDesc = arg.pdfPageInfo;
        };
        this._page.pdfPageNo = pdfPageNo;
        this._page.h = {
            type: "homography",
            a: NU_TO_PU, b: 0, c: 0,
            d: 0, e: NU_TO_PU, f: 0,
            g: 0, h: 0, i: 1,
            tx: 0, ty: 0
        };
        this._page.h_rev = {
            type: "homography",
            a: NU_TO_PU, b: 0, c: 0,
            d: 0, e: NU_TO_PU, f: 0,
            g: 0, h: 0, i: 1,
            tx: 0, ty: 0
        };
    }
    get srcPts() {
        return this._srcPts;
    }
    get dstPts() {
        return this._dstPts;
    }
}
//# sourceMappingURL=MappingItem.js.map